import { css } from "@emotion/react"

const reboot = (theme) => css`
  body {
    font-family: ${theme.typography.fontFamilyMontserrat};
  }

  html,
  body,
  #___gatsby,
  #gatsby-focus-wrapper {
    height: 100%;
  }

  #gatsby-focus-wrapper {
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    scroll-behavior: smooth;
  }

  .grecaptcha-badge {
    visibility: hidden;
  }

  h1 {
    ${theme.breakpoints.down("lg")} {
      font-size: 44px;
    }

    ${theme.breakpoints.between("lg", "2xl")} {
      font-size: 70px;
    }

    ${theme.breakpoints.up("2xl")} {
      font-size: 80px;
    }
  }

  h2 {
    ${theme.breakpoints.down("lg")} {
      font-size: 36px;
    }

    ${theme.breakpoints.between("lg", "2xl")} {
      font-size: 45px;
    }

    ${theme.breakpoints.up("2xl")} {
      font-size: 60px;
    }
  }

  .content {
    p {
      margin-top: 0;

      &:not(:last-child) {
        margin-bottom: 20px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      &[data-margin="before-list"] {
        margin-bottom: 0px;
      }
    }

    ul {
      padding-left: 20px;
    }

    ol {
      padding-left: 34px;
    }

    ul,
    ol {
      margin-top: 0;

      &:not(:last-child) {
        margin-bottom: 20px;
      }
    }

    p + br {
      margin-bottom: 30px;
    }

    ol br {
      margin-top: 0px;
    }

    br {
      margin-top: 10px;
    }

    a {
      color: ${theme.palette.gray[900]};
      border-bottom: 1px solid ${theme.palette.gray[900]};
      transition: all 0.2s;
      margin-bottom: -1px;
      max-width: max-content;
      text-decoration: none;
      width: 100%;
      font-weight: 600;

      u {
        text-decoration: none;
      }

      &:hover {
        border-color: transparent;
      }
    }

    br {
      content: "";
      display: block;
    }

    > * ~ br {
      display: none;
    }
  }
`

export default reboot
